/**
 * Application constants
 */
export class Constants {
  /** URL to get user information */
  static securityUserInfo = '/security/user';

  /** URL to check if a user has permission to access a resource */
  static securityUserAccess = '/security/access';

  /** URL to check if a user has an active session, otherwise
   *  returns the login form HTML
   */
  static securityCheckStatus = '/security/status';
}
